
export const getEvaluationUniqueKey = (evaluationFields) => {
    return [
        evaluationFields.studentId,
        evaluationFields.classroomId,
        evaluationFields.disciplineId,
        evaluationFields.evaluationPeriodId,
        evaluationFields.evaluationTypeId,
        evaluationFields.evaluationTypeIndex,
        evaluationFields.academicPeriodId
    ].join("-");
}

export const handleEvaluationResultData = (result) => {


    if (!(typeof (result) !== 'undefined' && result.length > 0)) {
        return result;
    }

    for (var i = 0; i < result.length; i++) {

        var resultItem = result[i];

        //Adicionando a o campo 'key' pra permitir a renderização da tabela sem erros
        //Adicionando a o campo 'index' pra permitir a ordenação da tabela (caso necessário)
        resultItem.key = result[i].id;
        resultItem.index = i;

        //Ajustando valores numericos a depender do tipo de avaliação

        if (resultItem?.evaluationType?.evaluationTypeTerms) {
            const numericValue = resultItem.points;
            const typeTerm = resultItem.evaluationType.evaluationTypeTerms.find(x => x.numericValue == numericValue);

            if (typeTerm) {
                resultItem.points = typeTerm.name;
            }
        }

        result[i] = resultItem;

    }
    return result;
}

const classroomEvaluateFunctions = {
    getEvaluationUniqueKey,
    handleEvaluationResultData
}

export default classroomEvaluateFunctions;